// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"styles_tableHeader__11h_y","number":"styles_number__2dblu","name":"styles_name__3oh5c","holding":"styles_holding__1aT0S","usdValue":"styles_usdValue__1r-IQ"};